module.exports = __webpack_public_path__ + "static/media/face-sad.d35ed95f.svg";